import React from 'react';
import { isPrerenderMode } from 'pro-gallery-lib';
export var LayoutFixer = function LayoutFixer(props) {
  // console.log('[LAYOUT FIXER] rendering', isPrerenderMode(), props);
  return isPrerenderMode ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "console.log(\"[LAYOUT FIXER] Start (first script loaded)\")"
    }
  }), /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "console.time(\"[LAYOUT FIXER] Done\")"
    }
  }), /*#__PURE__*/React.createElement("script", {
    src: props.layoutFixerBundleUrl
  }), /*#__PURE__*/React.createElement("layout-fixer", {
    parentId: props.parentId,
    items: JSON.stringify(props.items),
    styles: JSON.stringify(props.styles)
  })) : null;
};